export const useTimeInSec = (timeValue, timeUnit) => {
  let seconds = 0;
  switch (timeUnit) {
    case 'sec':
      seconds = timeValue;
      break;
    case 'min':
      seconds = timeValue * 60;
      break;
    case 'hr':
      seconds = timeValue * 3600;
      break;
    default:
      throw new Error('Invalid time unit');
  }
  return seconds.toString();
}
